// matcher.js
console.log('matcher.js loaded');

const APP_URL = 'https://dd4c-2a02-4780-e-2fcc-00-1.ngrok-free.app/api';

async function matchGoal(goal) {
  const res = await fetch(`${APP_URL}/match`, {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({ goal })
  });
  return res.json();
}

async function createDiscount(plan) {
  const res = await fetch(`${APP_URL}/create-discount`, {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({ plan })
  });
  return res.json();
}

function showAddedMessage(code) {
  alert(`Great! Your discount code ${code} is valid for 24 hours. Head to checkout to apply it.`);
}

function renderResults(data) {
  console.log('Rendering results', data);
  const container = document.querySelector('#wellness-matcher');
  let html = `<p><strong>${data.blurb}</strong></p>`;

  data.groups.forEach(group => {
    html += `<h3>${group.title}</h3>`;
    html += `<table>
      <tr>
        <th>Product</th><th>Dosage</th><th>Reason</th>
        <th>Price</th><th>6-Month</th><th>12-Month</th><th>Add</th>
      </tr>`;

    group.products.forEach(p => {
      html += `
        <tr data-id="${p.id}">
          <td><img src="${p.image}" style="max-width:20%;height:auto"><br>${p.name}</td>
          <td>${p.dosage}</td>
          <td>${p.reason}</td>
          <td>£${p.price}</td>
          <td>£${p.bundle6}<br>
            <button class="bundle" data-plan="6m">Add</button>
          </td>
          <td>£${p.bundle12}<br>
            <button class="bundle" data-plan="12m">Add</button>
          </td>
          <td><button class="single">Add</button></td>
        </tr>`;
    });

    html += `</table>`;
  });

  container.innerHTML = html;

  // Attach click handlers inside renderResults
  container.querySelectorAll('button.bundle, button.single').forEach(btn => {
    btn.addEventListener('click', async event => {
      event.preventDefault();

      // Debug log
      console.log('Button clicked!', event.target.dataset.plan);

      // 1. Get variant ID and plan
      const row = event.target.closest('tr');
      const variantId = parseInt(row.getAttribute('data-id'), 10);
      const plan = event.target.dataset.plan; // "6m", "12m" or undefined

      console.log('Adding to cart:', variantId);

      // 2. Add to cart
      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({ id: variantId, quantity: 6 })
        });
        const addData = await addRes.json();
        console.log('Cart response:', addData);
      } catch (err) {
        console.error('Cart error:', err);
        alert('Sorry, could not add to cart');
        return;
      }

      // 3. Create discount if bundle
      if (plan) {
        try {
          const { code } = await createDiscount(plan);
          console.log('Discount code:', code);
          showAddedMessage(code);
        } catch (err) {
          console.error('Discount error:', err);
          alert('Sorry, could not generate discount code');
        }
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, wiring form');
  const form = document.querySelector('#matcher-form');
  form.addEventListener('submit', async e => {
    e.preventDefault();
    console.log('Form submitted with goal:', form.goal.value);
    const data = await matchGoal(form.goal.value);
    renderResults(data);
  });
});
